/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'auth-settings';
const componentName = 'user-account-profile-mapping';
const prefix = `${moduleName}.${componentName}`;

export const userAccountProfileLabel = `${prefix}.userAccountProfileLabel`;
export const userProfileAttributeNameLabel = `${prefix}.userProfileAttributeNameLabel`;
export const userAccountProfilePlaceholderLabel = `${prefix}.userAccountProfilePlaceholderLabel`;
export const userProfileAttributeNamePlaceholderLabel = `${prefix}.userProfileAttributeNamePlaceholderLabel`;
export const typeDropdownPlaceholder = `${prefix}.typeDropdownPlaceholder`;

export const ENGLISH = {
    [userAccountProfileLabel]: 'User Account Profile',
    [userProfileAttributeNameLabel]: 'User Profile Attribute Name',
    [userAccountProfilePlaceholderLabel]: 'Select User Account Profile',
    [userProfileAttributeNamePlaceholderLabel]: 'Enter User Profile Attribute Name',
    [typeDropdownPlaceholder]: 'Select Type',
};
